<div class="vtz-main-wrapper" (window:resize)="onResize()">
    <div class="vtz-main-container vtz-main-container--home">
      <div class="vtz-title-section vtz-title-section--blue">
        <app-header></app-header>
      </div>
      <main>
        <div><h2 class="vtz-h1" i18n>{{title}}</h2></div>
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>{{petitionText}}</p>
        <h2 class="vtz-text vtz-text--center vtz-text--bold">
          <strong><i i18n ><span class="vtz--red">*</span> indicates a required field.</i></strong>
        </h2>
  
        <form [formGroup]="petitionForm" class="vtz-form">
          @for (field of fields; track field; let i = $index) {
            <div class="vtz-form__row">
              @switch (field.fieldType) {
                @case('lov') {
                  <div class="vtz-form__item">
                    <label class="vtz-form__label" for="{{field.fieldName}}">
                      <span i18n="Form field label">{{ field.fieldTitle }}</span>
                      @if (field.isMandatory) {
                        <span class="vtz--red">*</span>
                      }
                      @if (field.fieldTooltip !== undefined) {
                        <button id="tooltip-{{field.fieldName}}" class="vtz-tooltip"
                          matTooltip="{{field.fieldTooltip}}"
                          i18n-matTooltip="Tooltip information"
                          matTooltipPosition="after"
                          aria-label="Tooltip for input field"
                          i18n-aria-label="Explains to screen reader users what kind of element they are looking at"
                        (click)="onTooltipClick($event)"></button>
                      }
                    </label>
                    <select class="vtz-form__select" formControlName="{{field.fieldName}}" name="{{field.fieldName}}" id="{{field.fieldName}}" (blur)="onBlur(field.fieldName)">
                      <option value="null">Select</option>
                      @for (optionValue of pickerOptionsFor(field.fieldName); track optionValue; let i = $index) {
                        <option [value]="optionValue">{{optionValue}}</option>
                      }
                    </select>
                    @if(deliveryPristine) {
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">{{ field.fieldTitle }} is required.
                        </span>
                      </div>
                    }
                  </div>
                }
                @default {
                  <div class="vtz-form__item">
                    <label class="vtz-form__label" for="{{field.fieldName}}">
                      <span i18n="Form field label">{{ field.fieldTitle }}</span>
                      @if (field.isMandatory) {
                      <span class="vtz--red">*</span>
                      }
                      @if (field.fieldTooltip !== undefined) {
                      <button id="tooltip-{{field.fieldName}}"  class="vtz-tooltip"
                        matTooltip="{{field.fieldTooltip}}" i18n-matTooltip="Tooltip information" matTooltipPosition="after"
                        aria-label="Tooltip for input field "
                        i18n-aria-label="Explains to screen reader users what kind of element they are looking at"
                        (click)="onTooltipClick($event)"></button>
                      }
                    </label>
                    <input class="vtz-form__input" autocomplete="off" type="text" id="{{ field.fieldName }}"
                    formControlName="{{ field.fieldName }}"                      
                      name="{{ field.fieldName }}"
                      [attr.aria-required]="field.isMandatory ? 'true' : null" [attr.required]="field.isMandatory ? true : null"
                      [attr.aria-label]="field.fieldTitle" [ngClass]="{ 'vtz-form__input--error': petitionForm.controls[field.fieldName].dirty && petitionForm.controls[field.fieldName].invalid}" />
                    @if ( petitionForm.controls[field.fieldName].touched &&
                      petitionForm.controls[field.fieldName].errors?.required &&
                      field.isMandatory) {
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">{{ field.fieldTitle }} is required.
                        </span>
                      </div>
                    }
                    @if ( petitionForm.controls[field.fieldName].dirty &&
                      petitionForm.controls[field.fieldName].errors?.pattern) {
                      <div role="alert">
                        <span class="vtz-form__error" i18n="Invalid form field">Please enter a valid {{field.fieldTitle}}.</span>
                      </div>
                    }
                  </div>
                }
              }
            </div>
          }
        </form>
        <div #wrapper id="signature-pad">
          <div class="vtz-signature__pad-container">
          <canvas (touchstart)="touchedCanvas()" (click)="touchedCanvas()" #canvas class="vtz-signature__box" width="600" height="331" style="touch-action: none;"></canvas>
        </div>
        <div class="button-group button-group--flat-mobile">
          <button id="cancel-button" i18n class="button-secondary button--tiny" (click)="clear()">CLEAR</button>
          <button id="submit-button" i18n class="button-secondary button--tiny" (click)="undo()">UNDO</button>
        </div>
        </div>
        <div class="vtz-signature-actions">
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Once you are satisfied with your signature, click submit, or return to the petition to modify your selections.</p>
        <div class="vtz-actions">
          <div class="button-group button-group--flat-mobile">
              <button id="cancel-button" i18n class="button-primary" (click)="exit()">BACK</button>
              <button [disabled]="isEmpty.getValue() || !petitionForm.valid" id="open-submit-modal-button" i18n class="button-primary" (click)="openSubmitModal($event)">SUBMIT</button>
            </div>
        </div>
      </div>
    </main>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>